import React, { useState } from 'react';
import {
  fireClickedCouponFieldEvent,
  fireEnteredCouponEvent,
} from '../instrumentation';
import { CouponInputContainer, CouponInputSubtext } from './styled';

export default function CartCouponInput(props) {
  const {
    applyCouponClickHandler,
    setCouponInputError,
    couponInputError,
    toggle,
    couponInputRef,
    productIds,
  } = props;
  const [inputValue, setInputValue] = useState('');

  const couponSubmitHandler = (e) => {
    const couponCode = e.target[0].value;
    e.preventDefault();
    e.stopPropagation();
    if (couponCode) {
      applyCouponClickHandler({
        code: couponCode,
        name: couponCode,
      });
    } else {
      setCouponInputError({
        color: '#ef4e5e',
        message: '* Enter Valid Coupon',
      });
    }
  };
  return (
    <CouponInputContainer onSubmit={couponSubmitHandler}>
      <div className="textandbutton">
        <input
          onInput={(e) => {
            if (typeof e.target.value === 'string') {
              e.target.value = e.target.value.toUpperCase();
            }
          }}
          onChange={(e) => setInputValue(e?.target?.value)}
          className="coupon_input_field"
          type="text"
          placeholder={'Enter Coupon Code'}
          ref={couponInputRef}
          onClick={(e) => {
            if (toggle) e.stopPropagation();
            fireClickedCouponFieldEvent(productIds);
          }}
          onBlur={(e) => {
            fireEnteredCouponEvent(productIds, e.target.value);
          }}
        />

        <button
          type="submit"
          className="coupon_apply_button"
          disabled={inputValue === ''}
        >
          APPLY
        </button>
      </div>
      <CouponInputSubtext color={couponInputError?.color} className="subtext">
        {couponInputError?.message || ' '}
      </CouponInputSubtext>
    </CouponInputContainer>
  );
}
